import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { checkAdminAccess } from '../utils/adminService';

/**
 * 현재 사용자의 관리자 권한을 확인하는 훅
 */
export const useAdminCheck = () => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminCheckLoading, setAdminCheckLoading] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!authLoading && user) {
        try {
          setAdminCheckLoading(true);
          const adminStatus = await checkAdminAccess();
          setIsAdmin(adminStatus);
        } catch (error) {
          console.error('관리자 권한 확인 실패:', error);
          setIsAdmin(false);
        } finally {
          setAdminCheckLoading(false);
        }
      } else if (!authLoading && !user) {
        // 로그인되지 않은 경우
        setIsAdmin(false);
        setAdminCheckLoading(false);
      }
    };

    checkAdmin();
  }, [user, authLoading]);

  return {
    isAdmin,
    adminCheckLoading,
    isAuthReady: !authLoading && !adminCheckLoading
  };
};
